import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class TippyDropdown extends Component {
  @tracked tippyInstance = null;

  @action
  setTippyInstance(instance) {
    this.tippyInstance = instance;
  }

  get trigger() {
    return this.args?.trigger ?? 'click';
  }

  get placement() {
    return this.args.placement ?? 'bottom-start';
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get searchable() {
    return this.args?.options?.length >= 6;
  }

  @action
  focusSearch() {
    const search = document.querySelector('.inner-tippy-dropdown #searchable');
    if (search) search.focus();
  }

  willDestroy() {
    this.tippyInstance?.destroy?.();
    this.tippyInstance = null;
    super.willDestroy(...arguments);
  }
}
